import React from 'react'

import CardColumn from '@SonarCX/components/atoms/CardColumn'
import Card from '@SonarCX/components/atoms/Card'

import { getIcon } from '../PaymentSettings/helpers'
import { toTitleCase } from '@SonarCX/utilities'
import { usePayment } from '@SonarCX/providers/PaymentProvider'
import useStyles from './styles'

const PaymentCards: React.FC = () => {
  const { methods } = usePayment()

  const classes = useStyles()

  return (
    <CardColumn className={classes.root}>
      {methods.length === 0 && (
        <Card>
          <div className={classes.noData}>No payment methods</div>
        </Card>
      )}

      {methods.map((method, i) => {
        const Icon = getIcon(method)
        const brand = method.brand.split('_').map(toTitleCase).join(' ')

        return (
          <Card key={`${method.last4}-${i}`}>
            <div className={classes.dataRow}>
              <div>{method.name}</div>
            </div>

            <div className={classes.dataRow}>
              <div>Brand</div>

              <div
                style={{
                  display: 'flex',
                  alignItems: 'center'
                }}
              >
                <Icon className={classes.icon} />

                <div>{brand}</div>
              </div>
            </div>

            <div className={classes.dataRow}>
              <div>Last 4 digits</div>

              <div>****{method.last4}</div>
            </div>

            <div className={classes.dataRow}>
              <div>Exp</div>

              <div className={classes.expiration}>
                {method.exp_month}/{method.exp_year}
              </div>
            </div>
          </Card>
        )
      })}
    </CardColumn>
  )
}

export default PaymentCards
